import Kolang from './entries/ko_KR';
import { addLocaleData } from 'react-intl';

const AppLocale = {
  ko: Kolang,
};

export default AppLocale;
